import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContentService } from 'src/app/services/content.service';
import { ConfirmBoxComponent, DialogData } from '../dialog/confirm-box/confirm-box.component';
import { MatDialog } from '@angular/material/dialog';
import { IContentComponent } from 'src/app/interfaces/content-component.interface';
import { ContactInvitationService } from 'src/app/services/contact-invitation.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-contact-invitation',
  templateUrl: './contact-invitation.component.html',
  styleUrls: ['./contact-invitation.component.scss']
})
export class ContactInvitationComponent implements OnInit, OnDestroy, IContentComponent {

  private componentDestroyed = new Subject();

  pageComponentName: string = 'ContactInvitation';
  data!: Map<string, string>;

  contactInvitationId!: string;
  contactInvitationType!: number; //contact = 0, access = 1
  caseUid!: string;
  caseId!: string | null;

  PINCode!: string;
  invalidPin!: boolean;
  declined: boolean = false;

  constructor(
    private contactInvitationService: ContactInvitationService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private matDialog: MatDialog,
    private spinnerService: SpinnerService,
    private contentService: ContentService) {

    this.route.params
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (params: Params) => {
          this.caseUid = params['caseUid'];
          this.contactInvitationId = params['id'];
          this.contactInvitationType = +params['type'];
          this.contactInvitationService.checkContactInvitationValidity(this.contactInvitationId, this.contactInvitationType);
        }
      );

    this.contactInvitationService.contactInvitationValidityResult
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (caseId: string | null) => {
          this.caseId = caseId;
          this.contentService.loadContent('pageText', this.pageComponentName, ['text', 'label']);
        }
      );

    this.contactInvitationService.pinCodeValidationResult
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (value: boolean) => {
          if (value) {
            this.invalidPin = false;
            this.setContactInvitationResult(1); //1=approved, 3=rejected
            this.spinnerService.hide();  
          }
          else {
            this.invalidPin = true;
            this.spinnerService.hide();
          }
        }
      );

    this.contentService.content
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (data: Map<string, string>) => {
          if (data !== undefined) {
            this.data = data;
            this.setDataPlaceHolders();
          }
        }
      );
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  getLabelValue(label: string): string {
    let value: string = '';
    if (this.data) {
      value = this.data.get(label) ?? '';
    }
    return value;
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(null);
    this.componentDestroyed.unsubscribe();
  }

  setDataPlaceHolders(): void {

    if (this.data && this.caseId !== null) {
      let label: string = this.contactInvitationType === 0 ? 'ContactInvitationText' : 'ComplainerInvitationText';
      let text: string | undefined = this.data.get(label);
      if (text) {
        text = text.replace('[#CaseId]', this.caseId);
        this.data.set(label, text);
      }
    }
  }

  approveContactInvitation(): void {

    if (this.PINCode.length === 6) {
      this.spinnerService.show("Validerer PIN kode...");
      this.contactInvitationService.validatePinCode(this.contactInvitationId, this.PINCode);
    }
    else {
      this.invalidPin = true;
    }
  }

  denyContactInvitation(): void {

    let initialState: DialogData = {
      body: 'Er du sikker på at du ønsker å avslå invitasjonen?',
      title: 'Avslå invitasjon',
      okBtnName: 'Ja',
      closeBtnName: 'Nei'
    };

    const dialogRef = this.matDialog.open(ConfirmBoxComponent, { data: initialState })
    dialogRef.afterClosed()
      .subscribe(result => {
        if (result === true) {
          this.setContactInvitationResult(3); //1=approved, 3=rejected
        }
      }
    );
  }

  private setContactInvitationResult(status: number): void {
    this.contactInvitationService.setContactInvitationStatus(this.contactInvitationId, status)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (value: number) => {

          if (value === 1 && status === 1) {
            var url = '/contactinvitation/' + this.contactInvitationId + '/' + this.caseUid + '/' + this.contactInvitationType + '/approve';
            this.authenticationService.login(url);
          }
          else{
            this.declined = true;
            this.caseId = null;
          }
        },
        (error: HttpErrorResponse) => {
          console.log(error);
        },
        () => {
          console.log('Finished updated contactinvitation');
        }
      );
  }
}
